import { FormHelperText } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppConfig } from '../../../config/app';
import { AuthApi } from '../../../providers/api-provider';
import { RouteHistory } from '../../../providers/route-provider';
import { Loader, showError, showSuccess, simpleInputStateHandler } from '../libs/helpers';
import styles from './styles/login';
/* ResetPassword Component */
class ResetPassword extends React.Component {
  state = {
    data: {},
    loading: false,
    password_confirmation: '',
    password: '',
    error: '',

  }
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  /* API Call */
  performSendResetLink = async () => {
    if (this.state.password && this.state.password_confirmation) {
      await this.setState({ loading: true, error: '' });
      let data = this.state.data;
      data.password = this.state.password;
      data.password_confirmation = this.state.password_confirmation;
      try {
        await AuthApi.resetPassword(data);
        showSuccess('Password Changed Successfully!');
        RouteHistory.push('/');
        this.setState({ loading: false });
      } catch (error) {
        showError(error);
        if (error.response.data.errors && error.response.data.errors.password)
          this.setState({ loading: false, error: error.response.data.errors.password[0] });
        else
          this.setState({ loading: false, error: '' });
      }
    } else {
      showError('Please fill up all fields please!');
      this.setState({ loading: false, error: '' });
    }
  }
  fetchResetInfo = async () => {
    if (this.props.match.params.token) {
      await this.setState({ loading: true });
      try {
        let res = await AuthApi.resetPasswordFind(this.props.match.params.token);
        this.setState({ loading: false, data: res.data });
      } catch (e) {
        showError(e);
        RouteHistory.push('/');
        this.setState({ loading: false });
      }
    }
    else RouteHistory.push('/');
  }
  onChange = simpleInputStateHandler;
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  componentDidMount() {
    this.fetchResetInfo();
  }
  /* Render Page */
  render() {
    const { loading, error } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <main className={classes.main}>
          <CssBaseline />
          <Paper className={classes.paper}>
            <Avatar className={classes.avatar}>
              <img alt='edSeed Logo ' src={AppConfig.base+'/logo.png?v1'} style={{ width: '95%' }} />
            </Avatar>
            <Typography variant="body" style={{ width: '100%' }}>
              Enter your new password please
            </Typography>
            <FormControl margin="normal" fullWidth error={error}>
              <InputLabel htmlFor="password">Password</InputLabel>
              <Input name="password" autoComplete="password" type='password' onChange={this.onChange('password')} />
              {error ? <FormHelperText >{error}</FormHelperText> : ''}
            </FormControl>
            <FormControl margin="normal" fullWidth error={false} >
              <InputLabel htmlFor="password_confirmation">Confirm Password</InputLabel>
              <Input name="password_confirmation" type="password" onChange={this.onChange('password_confirmation')} />
            </FormControl>
            <Button
              disabled={loading}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={(e) => { e.preventDefault(); this.performSendResetLink(); }}
            >
              {loading ? <Loader size='20' /> : 'Reset Password'}
            </Button>
          </Paper>

        </main>

      </div>

    );
  }
}

ResetPassword.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(ResetPassword));